import { BaseRepository } from "@/repositories/base-repository"
import type { IProductionStatementCustomerPurchaseOrder } from "@/interfaces/api/production-statement-customer-purchase-order.interface"

export class ProductionStatementCustomerPurchaseOrderRepository extends BaseRepository<IProductionStatementCustomerPurchaseOrder> {
  protected resourcePath = "administration/production-statement-customer-purchase-orders"
}
